import { useEffect, useRef, useState } from "react";

interface Props {
	scrolledContainerRef: HTMLDivElement | null;
	offset?: number;
	debounceTime?: number;
}

const useScrolledToBottom = ({ scrolledContainerRef, offset = 10, debounceTime = 100 }: Props) => {
	const [scrolledToBottom, setScrolledToBottom] = useState(false);
	const scrollDebounce = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		if (scrolledContainerRef) {
			handleScroll();
			scrolledContainerRef.addEventListener("scroll", handleScroll);
		}

		return () => {
			if (scrolledContainerRef)
				scrolledContainerRef.removeEventListener("scroll", handleScroll);
		};
	}, [scrolledContainerRef, offset, debounceTime]);

	const handleScroll = () => {
		if (scrollDebounce.current)
			clearTimeout(scrollDebounce.current);

		scrollDebounce.current = setTimeout(() => {
			if (scrolledContainerRef) {
				const bottom = scrolledContainerRef.scrollHeight - scrolledContainerRef.scrollTop - scrolledContainerRef.clientHeight < offset;
				if (bottom) {
					setScrolledToBottom(true);
				} else {
					setScrolledToBottom(false);
				}
			}
		}, debounceTime);
	}

	return {
		scrolledToBottom,
	};
};

export default useScrolledToBottom;